/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 09:54:23
 * @LastEditTime: 2022-06-10 11:24:14
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelTax/Components/LocalisationSetting.tsx
 */
import { DebounceInput } from '@/src/components/Antd/Input/DebounceInput';
import Search from '@/src/components/Antd/Search/Search';
import CustomTable from '@/src/components/EditableTable/EditableTable';
import { SearchOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { Fragment, useMemo, useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const SubdivisionTranslationSetting = ({
  value: shopperTransSettings = [],
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [search, setSearch] = useState('');
  const data_first = get(shopperTransSettings, 'items[0].languages', []);
  const allColumns = data_first.map((item, index) => ({
    title: `${item.languageCode} ${index == 0 ? ' (Primary Language)' : ''}`,
    default: true,
    minWidth: 300,
    dataIndex: item.languageCode,
    key: item.languageCode,
    optional: index === 0 ? false : true,
    childGenerate: (_, record, ind) => {
      return (
        <div className={css.titleInput}>
          <div className={css.taxRuleTitle}>
            {index == 0 && record.taxRuleTitle}
          </div>

          <Form.Item
            className={css.formItem}
            name={['localization', 'items', ind, 'languages', index, 'title']}>
            <DebounceInput disabled={disabled} />
          </Form.Item>
        </div>
      );
    },
  }));

  const showLocalisationData = () =>
    useMemo(() => {
      const items = get(shopperTransSettings, 'items', []);
      if (search) {
        return items.filter(
          (o) =>
            o.taxRuleTitle.toLowerCase().indexOf(search.toLowerCase()) >= 0,
        );
      } else {
        return items;
      }
    }, [search, shopperTransSettings]);

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <Fragment>
      <Search
        enterButton={getI18n('general.filterGroup.search')}
        onSearch={handleSearch}
        prefix={<SearchOutlined />}
        allowClear
        placeholder={getI18n('salesChannelTax.index.searchtaxruletitle')}
        formClassName={css.search}
      />
      <div className={css.table}>
        <CustomTable
          id='localisationSetting'
          className={css.customTable}
          rowKey='taxUuid'
          dataSource={showLocalisationData() || []}
          columns={allColumns}
        />
      </div>
    </Fragment>
  );
};

export default SubdivisionTranslationSetting;
